import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { PutCsvExcelAccountsService } from "@/features/accounts/csv-excel/services/put-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import  { useContext } from "react";
import { MoneyLinkError, MoneyLinkException, ErrorLevel } from "@/shared/utils/custom-exception";


export const useUpdateCsvExcelAccounts = () => {
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);
  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const putCsvExcelAccountsService = new PutCsvExcelAccountsService();

  // CsvExcel口座更新
  const updateCsvExcelAccounts = async (
    accountGroupId: string,
    csvExcelAccountId: string,
    passbookName: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await putCsvExcelAccountsService.putCsvExcelAccounts({
        account_group_id:  accountGroupId,
        csvexcel_account_id: csvExcelAccountId,
        passbook_name: passbookName,
      });
      return true;
    } catch (error) {
      // エラーハンドリング
      console.log("updateCsvExcelAccounts", error);
      if (
        error instanceof MoneyLinkException &&
        error.error.props.reason === "webmoneylink_parameter_error"
      ) {
        throw new MoneyLinkException({
          error: new MoneyLinkError({
            level: ErrorLevel.Warn,
            code: error.error.props.code,
            reason: error.error.props.reason,
            messageTitle: undefined,
            messageBody:
              "Web明細帳名に使用できない文字が含まれているか、文字数が上限を超えています。\n入力内容をご確認ください。",
          }),
        });
      }
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    updateCsvExcelAccounts: errorHandledAsync(updateCsvExcelAccounts, setError),
  };
};
